export default class MessagingService {
  constructor($http, appConfig) {
    "ngInject";

    this.$http = $http;
    this.appConfig = appConfig;
  }

  getMessage(messageId) {
    return this.$http.get(this.appConfig.apiServiceBaseUri + `api/message/get//${messageId}`);
  }

  addMessage(msg) {
    return this.$http.post(this.appConfig.apiServiceBaseUri + 'api/message/add', msg);
  }

  listMessages(filterParams) {
    let query = '';

    query += `?pageStart=${filterParams.pageCriteria.pageStart}`;
    query += `&itemsToFetch=${filterParams.pageCriteria.itemsToFetch}`;
    query += `&sortExpression=${filterParams.pageCriteria.sortExpression}`;
    query += `&ascending=${filterParams.pageCriteria.ascending}`;
    query += `&userId=${filterParams.userId}`;
    query += `&messagesType=${filterParams.messagesType}`;

    return this.$http.get(this.appConfig.apiServiceBaseUri + 'api/message/list' + query);
  }
}



// WEBPACK FOOTER //
// ./client/app/components/messaging/messaging.service.js